import CloseIcon from '@mui/icons-material/Close';
import {
  Grid,
  IconButton,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import {getStyles} from '../Strengths/AllStrengthsDialogStyles';

import {EmpionPaper} from '../../../../../../components/EmpionPaper/EmpionPaper';
import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';
import {pdfH2} from '../../../../pdf/styles';

export interface ColumnDefinition<T> {
  key: keyof T;
  label: string;
  render: (item: T) => React.ReactNode;
  sx?: SxProps;
}

interface Props<T extends object> {
  data: T[];
  columns: ColumnDefinition<T>[];
  alternativeTitle?: string;
  onClose?: () => void;
  textStyleHeaders?: SxProps;
  textStyleBody?: SxProps;
  isCulturalDashboard?: boolean;
}

export const CulturalDashboardTable = <T extends object>({
  data,
  columns,
  alternativeTitle,
  onClose,
  textStyleHeaders,
  textStyleBody,
  isCulturalDashboard,
}: Props<T>) => {
  const {borderStyleRight, tableContainerStyles, tableHeadStyles, tableBodyStyles} = getStyles();

  return (
    <Grid container>
      {onClose && (
        <Grid item container justifyContent='space-between' alignItems='center' mb={2}>
          <Grid item xs={11}>
            <Typography variant='h2' sx={pdfH2}>
              {alternativeTitle}
            </Typography>
          </Grid>
          <Grid item xs={1} display='flex' justifyContent='flex-end'>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      )}
      <TableContainer
        component={EmpionPaper}
        sx={isCulturalDashboard ? tableContainerStyles : {background: orangeColors[5]}}
      >
        <Table>
          <TableHead
            sx={
              isCulturalDashboard
                ? {...tableHeadStyles, ...borderStyleRight}
                : {
                  ...tableHeadStyles,
                  ...borderStyleRight,
                  background: orangeColors[3],
                }
            }
          >
            <TableRow>
              {columns.map((col) => (
                <TableCell key={String(col.key)} sx={{...col.sx, color: greenColors[700]}}>
                  <Typography variant='h2' sx={{...textStyleHeaders, color: greenColors[700]}}>
                    {col.label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              ...tableBodyStyles,
              '& tr:nth-of-type(odd)': {backgroundColor: orangeColors[7]},
              '& tr:nth-of-type(even)': {backgroundColor: orangeColors[5]},
            }}
          >
            {data.map((item, index) => (
              <TableRow key={index}>
                {columns.map((col) => (
                  <TableCell key={String(col.key)} sx={{...col.sx, color: greenColors[700]}}>
                    <Typography variant='body1' sx={{...textStyleBody, color: greenColors[700]}}>
                      {col.render(item)}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};
